export const mmtColumns = [
    {
      name: "Service City",
      selector: (row) => row["city"],
      sortable: true,
      center: true,
    },
    {
      name: "Corporate Client",
      selector: (row) => row["companyName"],
      sortable: true,
      center: true,
    },
    {
      name: "Available for A2C",
      selector: (row) => row["A2C"],
      sortable: true,
      center: true,
    },
    {
      name: "Available for C2A",
      selector: (row) => row["C2A"],
      sortable: true,
      center: true,
    }
  ];